import { Link } from 'react-router-dom'

import { Card, CardBody } from '@/components/ui/Card'
import { ErrorState } from '@/components/ui/ErrorState'
import { LoadingState } from '@/components/ui/LoadingState'
import { PageHeader } from '@/components/ui/PageHeader'
import { SettlementRevenueSummaryCard } from '@/components/venue/SettlementRevenueSummaryCard'
import { useVenueSettlementRevenue } from '@/hooks/useVenueSettlementRevenue'
import { defaultRevenueFilter } from '@/lib/venue/settlementViewModel'
import { useVenueContext } from '@/routes/venueContext'

/** 하위 메뉴 진입 — `navItems` 미등록 서브라우트(`courts/:courtId/operating-hours`와 같은 관례). */
const SUB_MENU_LINKS: { path: string; label: string; description: string }[] = [
  { path: 'revenue', label: '매출 현황', description: '기간을 선택해 매출을 조회하고 CSV로 내려받습니다.' },
  { path: 'cycles', label: '정산 확정·예정', description: '회차별 정산 기준·확정 금액·지급일·상태를 확인합니다.' },
  { path: 'refunds', label: '환불 처리 결과', description: '환불 처리 상태·유형·정산 반영 여부를 조회합니다.' },
  { path: 'deductions', label: '분쟁환불 차감 내역', description: '다음 정산에서 차감되는 내역을 확인합니다.' },
]

/**
 * 매출·정산 관리 홈 — 'sales'(설계 §2). 이번 달 요약 + 하위 4메뉴 진입.
 * 🚨 이 화면은 조립만 한다. 상태 판정·서식은 `settlementViewModel.ts`/`format.ts`가 소유한다.
 */
export function VenueSalesHomePage() {
  const { venueId } = useVenueContext()

  const revenueQuery = useVenueSettlementRevenue(venueId, defaultRevenueFilter())

  return (
    <>
      <PageHeader title="매출·정산" description="이번 달 매출·정산 요약과 세부 화면으로 이동합니다." />

      {revenueQuery.isLoading ? <LoadingState rows={4} label="매출·정산 요약을 불러오는 중" /> : null}

      {revenueQuery.isError ? (
        <ErrorState
          error={revenueQuery.error}
          onRetry={() => {
            void revenueQuery.refetch()
          }}
        />
      ) : null}

      {revenueQuery.data ? (
        <div className="space-y-5">
          <SettlementRevenueSummaryCard data={revenueQuery.data} />

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {SUB_MENU_LINKS.map((link) => (
              <Link key={link.path} to={`/venues/${venueId}/sales/${link.path}`}>
                <Card className="h-full transition-colors hover:bg-slateish-50">
                  <CardBody>
                    <p className="text-sm font-semibold text-ink-700">{link.label}</p>
                    <p className="mt-1 text-xs text-slateish-600">{link.description}</p>
                  </CardBody>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      ) : null}
    </>
  )
}
